import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';

import BaseScreen from 'components/base-screen';
import { ButtonProps } from 'components/button';
import MainScreenContent from 'components/main-screen-content';

import { BuyApartmentFlowPaths } from 'routes';
import useViewApartmentDealsButtonProps from 'hooks/use-view-apartment-deals-button-props';
import useApartmentsFilterLimitsOnboarding from 'api/hooks/use-apartment-filter-limits-onboarding';

import styles from './styles.module.scss';

const BuyApartmentMain: React.FC = () => {
  const navigate = useNavigate();

  const { isLoading } = useApartmentsFilterLimitsOnboarding();

  const buttons: ButtonProps[] = [
    {
      ...useViewApartmentDealsButtonProps(),
      variant: 'gray',
      className: clsx(styles.viewApartmentsButton, !isLoading && styles.viewApartmentButtonShow),
    },
    {
      label: 'Подобрать квартиру',
      onClick: () => navigate(BuyApartmentFlowPaths.chooseApartmentComplex),
    },
  ];

  return (
    <BaseScreen padContent floatingButtons={false} title='Подбор объектов' buttons={buttons}>
      <MainScreenContent />
    </BaseScreen>
  );
};

export default BuyApartmentMain;
